import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'environments/environment';

export interface RuntimeConfig {
    keycloakUrl: string;
    keycloakRealm: string;
    keycloakClientId: string;
    apiUrl: string;
}

@Injectable({
    providedIn: 'root'
})
export class RuntimeConfigService {
    private config: RuntimeConfig;

    constructor(private http: HttpClient) { }

    async loadConfig(): Promise<void> {
        try {
            this.config = await firstValueFrom(this.http.get<RuntimeConfig>('assets/config.json'));
            console.info('Runtime configuration loaded:', this.config);
        } catch (error) {
            console.warn('Could not load runtime configuration, falling back to environment:', error);
            // Fallback to environment
            this.config = {
                keycloakUrl: environment.auth.url,
                keycloakRealm: environment.auth.realm,
                keycloakClientId: environment.auth.clientId,
                apiUrl: environment.apiUrl
            };
        }
    }

    get apiUrl(): string {
        // Ensure trailing slash if environment.url had it, or handle consistently
        return this.config.apiUrl.endsWith('/') ? this.config.apiUrl : this.config.apiUrl + '/';
    }

    get authConfig() {
        return {
            url: this.config.keycloakUrl,
            realm: this.config.keycloakRealm,
            clientId: this.config.keycloakClientId
        };
    }
}
